import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status"]
  static values = {
    uploadId: Number,
    interval: { type: Number, default: 3000 },
    statusUrl: String
  }

  connect() {
    if (this.uploadIdValue) {
      this.startPolling()
    }
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    // Don't start polling if upload is already completed
    if (this.element.dataset.uploadCompleted === 'true') {
      return
    }
    this.poll()
  }

  stopPolling() {
    if (this.pollTimer) {
      clearTimeout(this.pollTimer)
      this.pollTimer = null
    }
  }

  poll() {
    // Check if upload is still processing
    fetch(`/uploads/${this.uploadIdValue}/status.json`)
      .then(response => response.json())
      .then(data => {
        if (data.aasm_state === 'finished' || data.aasm_state === 'crashed' || data.aasm_state === 'stopped') {
          // Stop polling and refresh the status one final time
          this.stopPolling()
          this.refreshStatus()
          // Mark this controller as completed to prevent further polling
          this.element.dataset.uploadCompleted = 'true'
        } else {
          // Continue polling
          this.pollTimer = setTimeout(() => this.poll(), this.intervalValue)
        }
      })
      .catch(error => {
        console.error('Error polling upload status:', error)
        this.stopPolling()
      })
  }

  refreshStatus() {
    // Preserve the state of any open details elements before refresh
    const openDetails = []
    this.element.querySelectorAll('details[open]').forEach(details => {
      openDetails.push(details.id)
    })

    // Refresh the bulk status section from the URL supplied by the view
    if (!this.statusUrlValue) {
      return
    }

    fetch(this.statusUrlValue, {
      headers: {
        'Accept': 'text/vnd.turbo-stream.html'
      }
    })
      .then(response => response.text())
      .then(html => {
        Turbo.renderStreamMessage(html)

        // Restore the state of previously open details elements
        setTimeout(() => {
          openDetails.forEach(detailsId => {
            const details = document.getElementById(detailsId)
            if (details) {
              details.open = true
            }
          })
        }, 50)
      })
      .catch(error => {
        console.error('Error refreshing status:', error)
      })
  }
}
